<template>
  <div class="row">
    <div class="col-lg-12">
      <div
        v-if="created"
        class="alert alert-success"
        role="status">{{ created['@id'] }} {{$t('notifications.created')}}</div>
      <div
        v-if="updated"
        class="alert alert-success"
        role="status">{{ updated['@id'] }} {{$t('notifications.updated')}}</div>
      <div
        v-if="isLoading || deleteLoading"
        class="alert alert-info"
        role="status">{{$t('alerts.loading')}}...</div>
      <div
        v-if="error"
        class="alert alert-danger"
        role="alert">
        <span
          class="fa fa-exclamation-triangle"
          aria-hidden="true" ></span> {{ error }}
      </div>
      <div
        v-if="deleteError"
        class="alert alert-danger"
        role="alert">
        <span
          class="fa fa-exclamation-triangle"
          aria-hidden="true" ></span> {{ deleteError }}
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{$t('views.excmtask.update.title')}} {{ item && item['@id'] }}</h4>
        </div>
        <div class="card-body">
          <EXCMTaskForm
            v-if="item"
            :handle-submit="onSendForm"
            :handle-update-field="updateField"
            :values="item"
            :errors="violations"
            :initial-values="retrieved" />

          <router-link
            v-if="item"
            :to="{ name: 'EXCMTaskList' }"
            class="btn btn-default">{{$t('buttons.backToList')}}</router-link>
          <button
            class="btn btn-danger"
            @click="del">{{$t('buttons.delete')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMTaskForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  components: {
    EXCMTaskForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmtask/update/isLoading',
      error: 'excmtask/update/error',
      deleteError: 'excmtask/del/error',
      deleteLoading: 'excmtask/del/isLoading',
      created: 'excmtask/create/created',
      deleted: 'excmtask/del/deleted',
      retrieved: 'excmtask/update/retrieved',
      updated: 'excmtask/update/updated',
      violations: 'excmtask/update/violations'
    })
  },

  beforeCreate () {
    checkPagePermission('tasks', 'EXCMTaskUpdate')
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMTaskList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmtask/create/reset',
      deleteItem: 'excmtask/del/del',
      delReset: 'excmtask/del/reset',
      retrieve: 'excmtask/update/retrieve',
      updateReset: 'excmtask/update/reset',
      update: 'excmtask/update/update',
      updateRetrieved: 'excmtask/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmtask ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
